import { render, staticRenderFns } from "./Parts.vue?vue&type=template&id=ba008d12&scoped=true"
import script from "./Parts.vue?vue&type=script&lang=ts"
export * from "./Parts.vue?vue&type=script&lang=ts"
import style0 from "./Parts.vue?vue&type=style&index=0&id=ba008d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba008d12",
  null
  
)

export default component.exports